module.exports = __webpack_public_path__ + "static/media/survey_en.ad683893.mp4";